import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';

export async function getMe(fetch: Fetch) {
    return fetch('/auth/me', { method: 'GET' }, schemas.MeResponse);
}

export const useMeQuery = (fetch: Fetch) => {
    return useQuery({
        queryKey: ['me'],
        queryFn: async () => {
            try {
                const result = await getMe(fetch);
                return result;
            } catch (err) {
                console.error(err);
            }
        }
    });
};
